<template>
  <div class="flex align-items-center">
    <template v-if="isRated && rating < 0">
      {{ I18n.t("image.thank_you_for_rating") }}
    </template>
    <ShareSociaMedia v-else-if="isRated && rating === 1" />
    <template v-else>
      {{ I18n.t("image.rate_this_result") }}
      <IconButton
        class="ml-3"
        variant="secondary"
        :disabled="isRated"
        :title="I18n.t('image.rate_good')"
        @click="ratePositive(props.image)"
        ><ThumbsUpIcon
      /></IconButton>

      <template v-if="needsDialog()">
        <QIPDialog :image="props.image" @on-cancel="onQIPDialogCancel" @rate-negative="rateNegative(props.image)">
          <template #trigger>
            <IconButton variant="secondary" :title="I18n.t('image.rate_bad')"><ThumbsDownIcon /></IconButton>
          </template>
        </QIPDialog>
      </template>
      <template v-else>
        <IconButton
          variant="secondary"
          :disabled="isRated"
          :title="I18n.t('image.rate_bad')"
          @click="rateNegative(props.image)"
          ><ThumbsDownIcon
        /></IconButton>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import "@/src/i18n";
import { IconButton, ThumbsUpIcon, ThumbsDownIcon } from "prism";
import { onMounted, ref, watch, inject, computed } from "vue";
import Routes from "@/modules/routes";
import { Image, ProcessingState } from "@/modules/internal_api/image";

import QIPDialog from "./qip_dialog.vue";
import ShareSociaMedia from "@/components/share_social_media.vue";
import { useImageReporter } from "@/composables/image_reporter";

const I18n = inject("I18n");

interface RatingProps {
  image: Image;
}

const props = defineProps<RatingProps>();

const isRated = ref<Boolean>(false);
const rating = ref<Number>(0);
const { consented, rateNegative, ratePositive, needsDialog, updateConsentedValue } = useImageReporter();

onMounted(() => {
  updateConsentedValue();
  refresh();
});

watch(
  () => props.image,
  () => refresh()
);
watch(
  () => props.image.previewResult?.rating,
  () => refresh()
);

const refresh = () => {
  if (props.image.previewResult.state === ProcessingState.Finished) {
    isRated.value = props.image.previewResult.rated;
    rating.value = props.image.previewResult.rating;
  } else {
    isRated.value = false;
    rating.value = 0;
  }
};

const onQIPDialogCancel = () => {
  consented.value = false;
  rateNegative(props.image);
};

const ipc_url = computed(() => {
  return `<a href="${Routes.get("ipc_url")}" target="_blank">${I18n.t("improve.ipc")}</a>`;
});
</script>

<style>
.prism .dialog-wrapper {
  max-width: 480px !important;
  padding: 24px !important;
}
</style>
